var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeleteWorkspaceIconDefault = function SvgDeleteWorkspaceIconDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0481A0",
    fillRule: "evenodd",
    d: "m13.468 13.038 3.183 3.182-1.47 1.47L12 14.506l-3.182 3.182-1.47-1.469 3.183-3.182-3.181-3.18 1.469-1.47L12 11.57l3.181-3.182 1.47 1.469-3.183 3.181zm6.147-5.192v10.385h-2.527l.692-.693h1.143v-9H17.78l-.692-.692h2.527zM6.911 18.231H4.384V7.846h2.527l-.692.692H5.077v9h1.142l.692.693zm6.365-10.385-.693.692h-1.167l-.692-.692h2.552zm-2.552 10.385.692-.693h1.167l.693.693h-2.552zM21 18.923c0 .382-.31.692-.693.692H3.692A.692.692 0 0 1 3 18.923V6.462h18v12.461zM20.307 3H3.692c-1.147 0-2.077.93-2.077 2.077v13.846c0 1.147.93 2.077 2.077 2.077h16.615c1.147 0 2.077-.93 2.077-2.077V5.077c0-1.147-.93-2.077-2.077-2.077z"
  })));
};

export default SvgDeleteWorkspaceIconDefault;